import LinkedList from "ts-linked-list";

export interface Chapter {
    heading: string;
    colorName: ChapterColor;
    items: LinkedList<ChapterArticle>;
}

export interface ChapterArticleInline {
    heading: string;
    image?: string;
    link: string;
}

export type ChapterColor = "blueDark" | "blueMid" | "blueLight";

export async function getChapters(): Promise<Chapter[]> {
    const articlesImport = await import ("./articles");
    const articles = articlesImport.default;

    return Promise.resolve([
        {
            heading: "We do business responsibly",
            colorName: "blueDark",
            items: articles.filter(a => a.tocIndex.startsWith("1")) as LinkedList<ChapterArticle>
        },

        {
            heading: "We collaborate and interact",
            colorName: "blueLight",
            items: articles.filter(a => a.tocIndex.startsWith("2")) as LinkedList<ChapterArticle>
        },

        {
            heading: "We impact the future of people and our planet",
            colorName: "blueMid",
            items: articles.filter(a => a.tocIndex.startsWith("3")) as LinkedList<ChapterArticle>
        }
    ]);
}

export interface ChapterArticle {
    heading: string;
    image?: string;
    stampImage?: string; // icon image that is slightly rotated
    backgroundImage?: string;
    tocIndex: string;
    link: string;
    chapterColor: ChapterColor;
    introduction: string;
    keyTakeaways: string;
    standFor: string;
    meaning: {
        asEmployee: string;
        asLeader: string;
    };
    howToAct: {
        question: string;
        answer: string;
    }[];
    relatedMaterial: {
        text: string;
        url: string;
    }[];
    definitions: string | null;
}

export async function getChapterArticle(id: string) {
    const articlesImport = await import ("./articles");
    const articles = articlesImport.default;

    return articles.findNode(article => article.tocIndex === id);
}

export interface Article {
    heading: string;
    preHeading?: string;
    introduction?: string;
    body: string;
    link: string;
}

export async function getArticle(slug: string) {
    const articlesImport = await import ("./content");
    const articles = articlesImport.default;

    return articles.find(article => article.link === slug);
}